import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Table } from 'reactstrap';

const RemissionGuideDetailModal = ({ isOpen, toggle, guide }: { isOpen: boolean, toggle: () => void, guide: any }) => {
    if (!guide) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle}>
                Detalle de Guía de Remisión: <span className="text-primary">{guide.numeroAutorizacion || 'N/A'}</span>
            </ModalHeader>
            <ModalBody>
                <Row className="mb-3">
                    <Col md={6}>
                        <strong>Estado:</strong> <span className={`badge bg-${guide.estado === 'AUTORIZADO' ? 'success' : 'warning'}`}>{guide.estado}</span>
                    </Col>
                    <Col md={6} className="text-md-end">
                        <strong>Fecha Autorización:</strong> {guide.fechaAutorizacion}
                    </Col>
                </Row>

                <h5 className="mb-3">Información del Traslado</h5>
                <Row className="mb-3 p-3 bg-light rounded">
                    <Col md={6}>
                        <p className="mb-1"><strong>Transportista:</strong> {guide.transportista.razonSocial}</p>
                        <p className="mb-1"><strong>RUC Transportista:</strong> {guide.transportista.ruc}</p>
                        <p className="mb-0"><strong>Placa:</strong> {guide.transportista.placa}</p>
                    </Col>
                    <Col md={6}>
                        <p className="mb-1"><strong>Dir. Partida:</strong> {guide.dirPartida}</p>
                        <p className="mb-1"><strong>Inicio Transporte:</strong> {guide.fechaIniTransporte}</p>
                        <p className="mb-0"><strong>Fin Transporte:</strong> {guide.fechaFinTransporte}</p>
                    </Col>
                </Row>

                <h5 className="mb-3">Destinatario y Documentos</h5>
                <Row className="mb-3 p-3 bg-light rounded">
                    <Col md={6}>
                        <p className="mb-1"><strong>Destinatario:</strong> {guide.destinatario.razonSocial}</p>
                        <p className="mb-0"><strong>CI/RUC:</strong> {guide.destinatario.identificacion}</p>
                    </Col>
                    <Col md={6}>
                        <p className="mb-1"><strong>Dir. Destino:</strong> {guide.dirDestino}</p>
                        <p className="mb-1"><strong>Motivo Traslado:</strong> {guide.motivoTraslado}</p>
                        <p className="mb-0"><strong>Doc. Sustento:</strong> {guide.docSustento || 'N/A'}</p>
                    </Col>
                </Row>

                <h5 className="mb-3">Productos</h5>
                <Table bordered responsive>
                    <thead className="table-light">
                        <tr>
                            <th>Código</th>
                            <th>Descripción</th>
                            <th className="text-end">Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {guide.detalles.map((item: any, index: number) => (
                            <tr key={index}>
                                <td>{item.codigo}</td>
                                <td>{item.descripcion}</td>
                                <td className="text-end">{item.cantidad}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default RemissionGuideDetailModal;
